(function () {
  'use strict';

  var blok = document.querySelector('[data-kh]');
  if (!blok || !window.VTKabel) return;

  function lees(kiezer, naam, leeg) {
    var el = blok.querySelector(kiezer);
    if (!el) { if (leeg === undefined) console.warn('[Voltrade] keuzehulp: ' + naam + ' ontbreekt'); return leeg === undefined ? null : leeg; }
    try { return JSON.parse(el.textContent); }
    catch (e) { console.warn('[Voltrade] keuzehulp: ' + naam + ' is geen geldige JSON', e); return null; }
  }

  var catalogus = {};
  var kabels = lees('[data-kh-kabels]', 'de kabellijst') || [];
  var lader = lees('[data-kh-lader]', 'de mobiele lader', null);
  if (kabels.length === 0) {
    console.warn('[Voltrade] keuzehulp: geen kabels. Is er een collectie gekozen ' +
      'bij de sectie-instellingen, en hebben die producten een stroomsterkte- en fasen-metafield?');
  }
  var t = (blok.querySelector('[data-kh-teksten]') || {}).dataset || {};

  var kz = blok.querySelector('[data-kz]');
  var kiesMerk = blok.querySelector('[data-fit-merk]');
  var kiesModel = blok.querySelector('[data-fit-model]');
  var verder = blok.querySelector('[data-kh-verder]');
  var meldingEl = blok.querySelector('[data-kh-melding]');
  var nr = blok.querySelector('[data-kh-nr]');
  var naamEl = blok.querySelector('[data-kh-naam]');
  var voort = blok.querySelector('[data-kh-voort]');
  var lengtesEl = blok.querySelector('[data-kh-lengtes]');
  var zakelijk = document.body.classList.contains('vt-zakelijk');
  var pijl = (blok.querySelector('[data-kh-pijl]') || {}).innerHTML || '';

  var staat = { auto: null, kabel: null, laden: null, stap: 1 };
  var doorTimer = null;

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  }
  function vul(sjabloon, waarden) {
    var uit = String(sjabloon || '');
    Object.keys(waarden).forEach(function (k) {
      uit = uit.replace(new RegExp('\\{\\{?\\s*' + k + '\\s*\\}?\\}', 'g'), waarden[k]);
    });
    return uit;
  }
  function getal(n) {
    return Number(n).toLocaleString(document.documentElement.lang || undefined, { maximumFractionDigits: 1 });
  }
  function autoNaam() { return staat.auto ? (staat.auto.volnaam || staat.auto.naam) : ''; }

  function melding(tekst) {
    if (!meldingEl) return;
    meldingEl.textContent = tekst || '';
    meldingEl.hidden = !tekst;
  }

  function toon(n, vanGeschiedenis) {
    if (doorTimer) { clearTimeout(doorTimer); doorTimer = null; }
    staat.stap = n;
    blok.querySelectorAll('[data-kh-stap]').forEach(function (s) {
      s.classList.toggle('is-aan', s.dataset.khStap === String(n));
    });
    if (voort) voort.hidden = n === 4;
    if (n < 4) {
      if (nr) nr.textContent = vul(nr.dataset.sjabloon, { nr: n });
      if (naamEl) naamEl.textContent = naamEl.dataset['stap' + n] || '';
      blok.querySelectorAll('.vt-kh__balkjes i').forEach(function (x, i) { x.classList.toggle('is-aan', i < n); });
    }
    if (!vanGeschiedenis) {
      try { history.pushState({ vtKh: n }, ''); } catch (e) {}
    }
    var stap = blok.querySelector('[data-kh-stap="' + n + '"]');
    var kop = stap && stap.querySelector('h2');
    if (kop && n > 1) { try { kop.focus({ preventScroll: true }); } catch (e) { kop.focus(); } }
    var kaart = blok.querySelector('.vt-kh__kaart');
    if (kaart && kaart.getBoundingClientRect().top < 0) {
      window.scrollTo({ top: kaart.getBoundingClientRect().top + window.pageYOffset - 100 });
    }
  }
  window.addEventListener('popstate', function (e) {
    var n = e.state && e.state.vtKh;
    toon(n || 1, true);
  });
  try { history.replaceState({ vtKh: 1 }, ''); } catch (e) {}

  blok.querySelectorAll('[data-kh-terug]').forEach(function (k) {
    k.addEventListener('click', function () { history.back(); });
  });

  var uitvoering = VTKabel.uitvoeringVeld(blok.querySelector('[data-uitvoering]'));

  function vulModellen(handle) {
    kiesModel.innerHTML = '';
    var modellen = catalogus[handle] || [];
    var leeg = document.createElement('option');
    leeg.value = '';
    leeg.textContent = kiesModel.dataset.leeg || '';
    kiesModel.appendChild(leeg);
    modellen.forEach(function (m, i) {
      var o = document.createElement('option');
      o.value = String(i);
      o.textContent = VTKabel.modelLabel(m);
      o.dataset.naam = m.naam;
      kiesModel.appendChild(o);
    });
    kiesModel.disabled = modellen.length === 0;
  }
  function gekozenModel() {
    return (catalogus[kiesMerk.value] || [])[parseInt(kiesModel.value, 10)] || null;
  }
  function werkAutoBij() {
    var m = gekozenModel();
    staat.auto = m ? VTKabel.autoVoor(m, VTKabel.analyseerModel(m), uitvoering ? uitvoering.select.value : '?') : null;
    melding('');
  }

  kiesMerk.addEventListener('change', function () {
    staat.auto = null;
    melding('');
    if (uitvoering) uitvoering.verberg();
    if (!kiesMerk.value) {
      kiesModel.disabled = true;
      kiesModel.innerHTML = '<option value="">' + esc(kiesModel.dataset.eerst || '') + '</option>';
      return;
    }
    var handle = kiesMerk.value;
    kiesModel.disabled = true;
    window.VTCatalogus.laad().then(function (c) {
      catalogus = c || {};
      if (kiesMerk.value === handle) vulModellen(handle);
    }).catch(function () {
      kiesModel.disabled = true;
    });
  });
  kiesModel.addEventListener('change', function () {
    var m = gekozenModel();
    var analyse = m ? VTKabel.analyseerModel(m) : null;
    if (uitvoering) {
      if (analyse && analyse.vraag) uitvoering.toon(m, analyse);
      else uitvoering.verberg();
    }
    werkAutoBij();
  });
  if (uitvoering) uitvoering.select.addEventListener('change', werkAutoBij);

  verder.addEventListener('click', function () {
    if (!staat.auto) { melding(t.kiesAuto); return; }
    if (VTKabel.isType1(staat.auto.aansluiting)) { melding(vul(t.type1, { naam: autoNaam() })); return; }
    var b = VTKabel.beste(staat.auto, kabels);
    staat.kabel = b ? b.kabel : null;
    if (!staat.kabel) { melding(vul(t.type1, { naam: autoNaam() })); return; }
    var regel = blok.querySelector('[data-kh-auto]');
    var naam = autoNaam();
    if (uitvoering && !uitvoering.select.closest('[hidden]')) {
      var o = uitvoering.select.options[uitvoering.select.selectedIndex];
      var v = uitvoering.select.value;
      if (o && v !== '' && v !== '?') naam += ' · ' + o.textContent;
    }
    if (regel) regel.textContent = vul(t.auto, { naam: naam });
    toon(2);
  });

  blok.querySelectorAll('[data-kh-modus]').forEach(function (l) {
    l.addEventListener('click', function () {
      melding('');
      var tab = kz && kz.querySelector('[data-kz-tab="' + l.dataset.khModus + '"]');
      if (tab) tab.click();
      var doel = l.dataset.khModus === 'kenteken' ? blok.querySelector('[data-kz-plaat]') : kiesMerk;
      setTimeout(function () { if (doel) doel.focus({ preventScroll: true }); }, 50);
    });
  });

  var ladenKnoppen = [].slice.call(blok.querySelectorAll('[data-kh-laden]'));
  ladenKnoppen.forEach(function (k) {
    k.addEventListener('click', function () {
      staat.laden = k.dataset.khLaden;
      ladenKnoppen.forEach(function (x) { x.setAttribute('aria-pressed', x === k ? 'true' : 'false'); });
      bouwLengtes();
      setTimeout(function () { toon(3); }, 160);
    });
  });

  function product() { return staat.laden === 'mobiel' ? lader : staat.kabel; }
  function uitleg(meter) {
    var sleutel = String(meter).replace('.', '_');
    return (staat.laden === 'mobiel' ? t['lader-' + sleutel] : t['lengte-' + sleutel]) || '';
  }

  function bouwLengtes() {
    var p = product();
    blok.querySelectorAll('[data-kh-als]').forEach(function (el) { el.hidden = el.dataset.khAls !== staat.laden; });
    if (!p || !lengtesEl) return;
    lengtesEl.innerHTML = (p.lengtes || []).map(function (v, i) {
      var sub = uitleg(v.meter);
      return '<button type="button" class="vt-kh__keuze" data-kh-lengte="' + i + '" aria-pressed="false">' +
        '<span class="vt-kh__keuze-t"><b>' + esc(v.label) + '</b>' + (sub ? '<span>' + esc(sub) + '</span>' : '') + '</span>' +
        (zakelijk ? '' : '<em class="vt-kh__keuze-p">' + v.prijs + '</em>') + pijl + '</button>';
    }).join('');
  }
  lengtesEl && lengtesEl.addEventListener('click', function (e) {
    var k = e.target.closest('[data-kh-lengte]');
    if (!k) return;
    lengtesEl.querySelectorAll('[data-kh-lengte]').forEach(function (x) { x.setAttribute('aria-pressed', x === k ? 'true' : 'false'); });
    var v = (product().lengtes || [])[parseInt(k.dataset.khLengte, 10)];
    setTimeout(function () { klaar(v); }, 160);
  });

  var weetniet = blok.querySelector('[data-kh-weetniet]');
  if (weetniet) weetniet.addEventListener('click', function () {
    var lijst = (product() || {}).lengtes || [];
    var v = lijst.filter(function (x) { return x.meter >= 7.5; })[0] || lijst[lijst.length - 1];
    if (v) klaar(v);
  });

  function klaar(v) {
    if (!v) return;
    var p = product();
    var mobiel = staat.laden === 'mobiel';
    var waarom;
    if (mobiel) {
      waarom = vul(t.waaromLader, { naam: autoNaam() });
    } else {
      var licht = staat.kabel.ampere <= 16;
      waarom = vul(licht ? t.waaromLicht : t.waaromZwaar, { naam: autoNaam(), ampere: getal(VTKabel.stroom(staat.auto)) });
    }
    blok.querySelector('[data-kh-klaar-kop]').textContent = vul(t.klaarKop, { naam: autoNaam() });
    blok.querySelector('[data-kh-klaar-titel]').textContent = p.titel + ', ' + v.label;
    blok.querySelector('[data-kh-klaar-waarom]').textContent = waarom;
    blok.querySelector('[data-kh-klaar-prijs]').innerHTML = v.prijs;
    blok.querySelector('[data-kh-ico-paal]').hidden = mobiel;
    blok.querySelector('[data-kh-ico-mobiel]').hidden = !mobiel;
    var naar = blok.querySelector('[data-kh-naar]');
    naar.href = v.url || p.url;
    toon(4);
    doorTimer = setTimeout(function () { window.location.href = naar.href; }, 900);
  }
})();
